import React, { useRef } from "react";
import "../../styling/Account.css";
import profilePicture from "../../images/John-Wick.jpg.avif";
import { FaUpload } from "react-icons/fa";
import { FaTrash } from "react-icons/fa";
import { FaRegCircleCheck } from "react-icons/fa6";
import { useProfile } from "../../ProfileContext";
import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const ClientAccountInfo = (clientData) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: clientData?.clientData.name || "",
    lastName: clientData?.clientData.lastName || "",
    email: clientData?.clientData.email || "",
    phone: clientData?.clientData.phone || "",
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
const handleSave = async () => {
  const { name, lastName, email, phone } = formData;

  if (!name || !lastName || !email || !phone) {
    alert("All fields are required");
    return;
  }

  try {
    await axios.post(
      `${process.env.REACT_APP_API_URL}/edit-client/${clientData?.clientData?._id}`,
      formData,
      { withCredentials: true }
    );
    alert("Details saved successfully");
  } catch (err) {
    console.error("Error saving details:", err);
    alert("Failed to save details");
  }
};


  const { profileImage, setProfileImage } = useProfile();

  const clientAccountRef = useRef(null);
  const handleClientImageButtonClick = () => {
    clientAccountRef.current.click();
  };
  const handleClientImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const formData = new FormData();
    console.log("📌 handleClientProfileImageUpload called!");
    formData.append("profilePic", file);
    try {
      console.log("🚀 Sending API request...");
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/client/upload-profile`,
        formData,
        {
          withCredentials: true,
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      console.log("📤 Image uploaded successfully:", response.data);
      setProfileImage(response.data.profilePic);
      console.log("Image set");
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };
 

  const [currentPassword, setCurrentPassword] = useState();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleChangePassword = async () => {
    if (newPassword !== confirmPassword) {
      alert("New password and confirm password do not match");
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/client-user/change-password`,
        {
          currentPassword,
          newPassword,
        },
        { withCredentials: true }
      );
      alert("Password changed successfully");
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || "Failed to change password");
    }
  };

  const [password, setPassword] = useState("");
  const [confirmDeletePassword, setConfirmDeletePassword] = useState("");
  
  const handleDelete = async () => {
  if (!password || !confirmDeletePassword) {
    alert("Please enter both password fields.");
    return;
  }

  if (password !== confirmDeletePassword) {
    alert("Passwords do not match.");
    return;
  }

  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_URL}/client-user/delete-account`,
      {
        data: { password }, 
        withCredentials: true, 
      }
    );

    alert("Account deleted successfully.");
    navigate("/login");
  } catch (error) {
    alert(
      error?.response?.data?.message || "Failed to delete account. Try again."
    );
  }
};

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ width: "57%" }} className="account-info-container">
        <div className="accountInfo" style={{ padding: "0px" }}>
          <div>
            {" "}
            <h2>Account</h2>{" "}
          </div>
        </div>
        <div
          style={{
            height: "130px",
            backgroundColor: "#FFFFFF",
            marginBottom: "20px",
            padding: "6%",
            paddingTop: "5%",
          }}
        >
          <h2
            style={{
              color: "#1C1154",
              fontWeight: "450",
              marginBottom: "25px",
            }}
          >
            Profile Image
          </h2>
          <div style={{ display: "flex" }} className="account-profile">
            <img
              src={profileImage}
              alt="Profile"
              style={{ width: "70px", height: "70px", borderRadius: "50%" }}
            />
            <div
              className="accountButtons"
              style={{
                gap: "17px",
                marginLeft: "4%",
                width: "100%",
                alignItems: "center",
              }}
            >
              <input
                type="file"
                style={{ display: "none" }}
                ref={clientAccountRef}
                onChange={handleClientImageUpload}
              />
              <button
                style={{
                  width: "25%",
                  height: "40px",
                  fontSize: "14px",
                  background: "#FFFFFF",
                  border: "1px solid #D9D9D9",
                  color: "#1C1154",
                }}
                onClick={handleClientImageButtonClick}
              >
                <FaUpload /> Upload
              </button>
              <button
                style={{
                  width: "25%",
                  height: "40px",
                  fontSize: "14px",
                  background: "#F2F2F2",
                  border: "1px solid #D9D9D9",
                  color: "#1C1154",
                }}
              >
                {" "}
                <FaTrash /> Delete
              </button>
            </div>
          </div>
        </div>

        <div
          style={{
            backgroundColor: "#FFFFFF",
            marginBottom: "20px",
            padding: "6%",
            paddingTop: "5%",
          }}
        >
          <h2
            style={{
              color: "#1C1154",
              fontWeight: "450",
              marginBottom: "25px",
            }}
          >
            Account Info
          </h2>

          <div style={{ display: "flex" }}>
            <div style={{ width: "50%" }}>
              <div
                style={{
                  color: "#625C73",
                  marginTop: "20px",
                  marginBottom: "10px",
                  fontSize: "12px",
                }}
              >
                First Name
              </div>
              <input
                name="name"
                value={formData.name}
                onChange={handleChange}
                style={{
                  border: "none",
                  borderBottom: "2px solid #D9D9D9",
                  fontSize: "15px",
                  width: "100%",
                }}
              />
            </div>
            <div style={{ width: "50%" }}>
              <div
                style={{
                  color: "#625C73",
                  marginTop: "20px",
                  marginBottom: "10px",
                  fontSize: "12px",
                }}
              >
                Last Name
              </div>
              <input
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                style={{
                  border: "none",
                  borderBottom: "2px solid #D9D9D9",
                  fontSize: "15px",
                  width: "100%",
                }}
              />
            </div>
          </div>

          <div style={{ display: "flex" }}>
            <div style={{ width: "50%" }}>
              <div
                style={{
                  color: "#625C73",
                  marginTop: "20px",
                  marginBottom: "10px",
                  fontSize: "12px",
                }}
              >
                Email
              </div>
              <input
                name="email"
                value={formData.email}
                onChange={handleChange}
                style={{
                  border: "none",
                  borderBottom: "2px solid #D9D9D9",
                  fontSize: "15px",
                  width: "100%",
                }}
              />
            </div>
            <div style={{ width: "50%" }}>
              <div
                style={{
                  color: "#625C73",
                  marginTop: "20px",
                  marginBottom: "10px",
                  fontSize: "12px",
                }}
              >
                Phone Number
              </div>
              <input
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                style={{
                  border: "none",
                  borderBottom: "2px solid #D9D9D9",
                  fontSize: "15px",
                  width: "100%",
                }}
              />
            </div>
          </div>

          <div style={{ marginTop: "40px" }}>
            <button
              onClick={handleSave}
               style={{
              marginTop: "20px",
              height: "40px",
              width: "30%",
              background: "#FFFFFF",
              border: "1px solid #D9D9D9 ",
              color: "#1C1154",
              fontSize: "17px",
              fontWeight: "450",
              cursor: "pointer",
            }}
            >
              Save Details
            </button>
          </div>
        </div>

        {/* <div
          style={{
            height: "346px",
            backgroundColor: "#FFFFFF",
            marginBottom: "20px",
            padding: "6%",
            paddingTop: "5%",
          }}
        >
          <h2
            style={{
              color: "#1C1154",
              fontWeight: "450",
              marginBottom: "25px",
            }}
          >
            Password Security
          </h2>
          <div style={{ width: "100%" }}>
            <div
              style={{
                color: "#625C73",
                marginTop: "20px",
                marginBottom: "10px",
                fontSize: "12px",
              }}
            >
              {" "}
              Current Password
            </div>
            <input
              placeholder="*************"
              style={{
                border: "hidden",
                borderBottom: "2px solid #D9D9D9",
                fontSize: "15px",
                width: "100%",
              }}
            ></input>
          </div>
          <div style={{ width: "100%" }}>
            <div
              style={{
                color: "#625C73",
                marginTop: "20px",
                marginBottom: "10px",
                fontSize: "12px",
              }}
            >
              {" "}
              New Password
            </div>
            <input
              placeholder="*************"
              style={{
                border: "hidden",
                borderBottom: "2px solid #D9D9D9",
                fontSize: "15px",
                width: "100%",
              }}
            ></input>
          </div>
          <div style={{ width: "100%" }}>
            <div
              style={{
                color: "#625C73",
                marginTop: "20px",
                marginBottom: "10px",
                fontSize: "12px",
              }}
            >
              {" "}
              Confirm Password
            </div>
            <input
              placeholder="*************"
              style={{
                border: "hidden",
                borderBottom: "2px solid #D9D9D9",
                fontSize: "15px",
                width: "100%",
              }}
            ></input>
          </div>
          <button
            style={{
              marginTop: "20px",
              height: "40px",
              width: "40%",
              background: "#FFFFFF",
              border: "1px solid #D9D9D9 ",
              color: "#1C1154",
              fontSize: "17px",
              fontWeight: "450",
            }}
          >
            Change Password
          </button>
        </div> */}

        <div
        style={{
          height: "346px",
          backgroundColor: "#FFFFFF",
          marginBottom: "20px",
          padding: "6%",
          paddingTop: "5%",
        }}
      >
        <h2
          style={{ color: "#1C1154", fontWeight: "450", marginBottom: "25px" }}
        >
          Password Security
        </h2>
        <div style={{ width: "100%" }}>
          <div
            style={{
              color: "#625C73",
              marginTop: "20px",
              marginBottom: "10px",
              fontSize: "12px",
            }}
          >
            {" "}
            Current Password
          </div>
          <input
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            style={{
              border: "hidden",
              borderBottom: "2px solid #D9D9D9",
              fontSize: "15px",
              width: "100%",
            }}
          ></input>
        </div>
        <div style={{ width: "100%" }}>
          <div
            style={{
              color: "#625C73",
              marginTop: "20px",
              marginBottom: "10px",
              fontSize: "12px",
            }}
          >
            {" "}
            New Password
          </div>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            style={{
              border: "hidden",
              borderBottom: "2px solid #D9D9D9",
              fontSize: "15px",
              width: "100%",
            }}
          ></input>
        </div>
        <div style={{ width: "100%" }}>
          <div
            style={{
              color: "#625C73",
              marginTop: "20px",
              marginBottom: "10px",
              fontSize: "12px",
            }}
          >
            {" "}
            Confirm Password
          </div>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={{
              border: "hidden",
              borderBottom: "2px solid #D9D9D9",
              fontSize: "15px",
              width: "100%",
            }}
          ></input>
        </div>
        <button
          style={{
            marginTop: "20px",
            height: "40px",
            width: "30%",
            background: "#FFFFFF",
            border: "1px solid #D9D9D9 ",
            color: "#1C1154",
            fontSize: "17px",
            fontWeight: "450",
          }}
          onClick={handleChangePassword}
        >
          Change Password
        </button>
      </div> 

        {/* <div
          style={{
            height: "260px",
            backgroundColor: "#FFFFFF",
            marginBottom: "20px",
            padding: "6%",
            paddingTop: "5%",
          }}
        >
          <h2
            style={{
              color: "#1C1154",
              fontWeight: "450",
              marginBottom: "25px",
            }}
          >
            Delete Account
          </h2>
          <div style={{ width: "100%" }}>
            <div
              style={{
                color: "#625C73",
                marginTop: "20px",
                marginBottom: "10px",
                fontSize: "12px",
              }}
            >
              {" "}
              Password
            </div>
            <input
              placeholder="*************"
              style={{
                border: "hidden",
                borderBottom: "2px solid #D9D9D9",
                fontSize: "15px",
                width: "100%",
              }}
            ></input>
          </div>
          <div style={{ width: "100%" }}>
            <div
              style={{
                color: "#625C73",
                marginTop: "20px",
                marginBottom: "10px",
                fontSize: "12px",
              }}
            >
              {" "}
              Confirm Password
            </div>
            <input
              placeholder="*************"
              style={{
                border: "hidden",
                borderBottom: "2px solid #D9D9D9",
                fontSize: "15px",
                width: "100%",
              }}
            ></input>
          </div>
          <button
            style={{
              marginTop: "20px",
              height: "40px",
              width: "30%",
              background: "#FFFFFF",
              border: "1px solid #D9D9D9 ",
              color: "#1C1154",
              fontSize: "17px",
              fontWeight: "450",
            }}
          >
            Delete Account
          </button>
        </div> */}

        <div
      style={{
        height: "260px",
        backgroundColor: "#FFFFFF",
        marginBottom: "20px",
        padding: "6%",
        paddingTop: "5%",
      }}
    >
      <h2
        style={{ color: "#1C1154", fontWeight: "450", marginBottom: "25px" }}
      >
        Delete Account
      </h2>

      <div style={{ width: "100%" }}>
        <div
          style={{
            color: "#625C73",
            marginTop: "20px",
            marginBottom: "10px",
            fontSize: "12px",
          }}
        >
          Password
        </div>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{
            border: "hidden",
            borderBottom: "2px solid #D9D9D9",
            fontSize: "15px",
            width: "100%",
          }}
        />
      </div>

      <div style={{ width: "100%" }}>
        <div
          style={{
            color: "#625C73",
            marginTop: "20px",
            marginBottom: "10px",
            fontSize: "12px",
          }}
        >
          Confirm Password
        </div>
        <input
          type="password"
          value={confirmDeletePassword}
          onChange={(e) => setConfirmDeletePassword(e.target.value)}
          style={{
            border: "hidden",
            borderBottom: "2px solid #D9D9D9",
            fontSize: "15px",
            width: "100%",
          }}
        />
      </div>

      <button
        onClick={handleDelete}
        style={{
          marginTop: "20px",
          height: "40px",
          width: "30%",
          background: "#FFFFFF",
          border: "1px solid #D9D9D9 ",
          color: "#1C1154",
          fontSize: "17px",
          fontWeight: "450",
          cursor: "pointer",
        }}
      >
        Delete Account
      </button>
    </div>
      </div>
    </div>
  );
};

export default ClientAccountInfo;
